export const PAGES_WITH_SELECTABLE_TASK_VIEW = [
  'week/current',
  'next/7/days',
  'next/14/days',
].map((route) => `/app/${route}`);
